import { Component, OnInit } from '@angular/core';
import { StoreService } from '../store.service';
import { Store } from '../store';
import { Router } from '@angular/router';
 
@Component({
  selector: 'app-store',
  templateUrl: './store.component.html',
  styleUrls: ['./store.component.css'],
  providers: [StoreService]
})
export class StoreComponent implements OnInit {

	stores: Store[];	


  constructor(private storeService: StoreService,private router: Router) {}

  ngOnInit() {
  			this.storeService.getStore().subscribe(store=>{this.stores=store['data'];});
  }

  clicked():void {
   		this.router.navigate(['/dashboard/store-crud']);
  }  

  clickedId(id: any){
    	 this.router.navigate(['/dashboard/store-crud/',id]);
  }

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/stores/store/store.component.ts